import * as React from 'react';

function StarSub(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" viewBox="0 0 24 20" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M19.5703 20H0L3.42965 0H23L19.5703 20Z" fill="#D70A0A" />
      <path
        d="M15.8 7.06667L13.2334 4.5M15.8 7.06667L13.2334 9.63333M15.8 7.06667H7.00015"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.46665}
      />
      <path
        d="M7.00008 12.9333L9.5667 15.5M7.00008 12.9333L9.5667 10.3667M7.00008 12.9333L15.7999 12.9333"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.46665}
      />
    </svg>
  );
}

export default StarSub;
